import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { OfferService } from '../../../shared/providers/offer.service';
import { DateValidator, ValidationService } from '../../../shared/providers/validation.service';
import { IChartData, InnerData } from '../../../shared/models/IChartData';
import { LoaderService } from '../../../shared/providers/loader.service';
import { SharedService } from '../../../shared/providers/shared.service';
import { Trade1031Service } from '../../../shared/providers/Trade1031.service';
import * as Highcharts from 'highcharts';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastService } from '../../../shared/providers/toast.service';
declare var require: any;
//require('highcharts/modules/map')(Highcharts);
if (typeof Highcharts === 'object') {

  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}

interface IPhaseInputModel {
  AssociatedStatusId: number;
  PhaseName: string;
  StartDate: Date;
  EndDate: Date
  IsPhaseCompleted: boolean;
  CompletedDate?: Date;
  IsEditAllDates: boolean;
  loggedinuserid: number;
  OfferGuid: string;
}

interface IEditPhaseInputModel {
  LOIStartDate: Date;
  LOIEndDate: Date;
  PSAStartDate: Date;
  PSAEndDate: Date;
  DDStartDate: Date;
  DDEndDate: Date;
  HCStartDate: Date;
  HCEndDate: Date;
  LOICompletedDate?: Date;
  PSACompletedDate?: Date;
  DDCompletedDate?: Date;
  HCCompletedDate?: Date;
  IsLOICompleted?: boolean;
  IsPSACompleted?: boolean;
  IsDDCompleted?: boolean;
  IsHCCompleted?: boolean;
}

@Component({
  selector: 'app-offer-progress-chart',
  templateUrl: './offer-progress-chart.component.html',
  styleUrls: ['./offer-progress-chart.component.css']
})
export class OfferProgressChartComponent implements OnInit {

  @Input() inputOfferGuid: string = "";
  constructor(private offerService: OfferService, public Validation: ValidationService, private Loader: LoaderService, private Shared: SharedService, private trade1031Service: Trade1031Service, private authService: AuthenticationService, private _toastService: ToastService, private modalService: BsModalService) {
    this.initializeChart();
  }
  offerGuid = '';
  chartDataReesponse: IChartData[];
  modalRef: BsModalRef;
  modalRefPhaseDateConfirmation: BsModalRef;
  EditPhaseForm: FormGroup;
  isEditPhaseFormSubmitted = false;
  PhaseInputModel = {} as IEditPhaseInputModel;
  PhaseInput = {} as IPhaseInputModel;
  phaseNumber: number;
  isLOIPhaseCompletedDateInvalid = false;
  isPSAPhaseCompletedDateInvalid = false;
  isDDPhaseCompletedDateInvalid = false;
  isHCPhaseCompletedDateInvalid = false;
  chartData = [];
  startDate: any;
  endDate: any;
  currentDate: any;
  date_45: any;
  Aday: number = 24 * 3600 * 1000;

  options: Object;

  initializeChart() {
    this.options = {
      title: {
        text: ""
      }
      , credits: {
        enabled: false
      }
    }
    //this.chart.options = this.options;
  }
  selectedExchange = 0;
  blockChartRebind = false;
  tradeStartDate: Date;
  tradeEndDate: Date;
  user: any;
  ngOnInit() {
    this.Loader.display(true)
    this.user = this.authService.user != null ? this.authService.user : "";
    this.offerGuid = this.inputOfferGuid;
    this.offerService.getOfferDetails(this.offerGuid).subscribe(response => {
      if (response.ExchangeId !== null) {
        this.exchangeOffer = true;
        this.offerType = "1031 Trade";
        this.trade1031Service.GetExchangeDetails(response.ExchangeId, this.user.Id).subscribe(res => {
          let startDate = res.ProjectedSaleDate;
          this.tradeStartDate = this.Validation.convertUTCDateToLocalDate(res.ProjectedSaleDate);
          this.tradeEndDate = this.Validation.DateAdd(this.tradeStartDate, 180);
          let dateString = [];
          dateString = this.Validation.formatDate(this.Validation.convertUTCDateToLocalDate(new Date(startDate)), "yyyy/M/dd").split('/');
          this.tradeStart = Date.UTC(dateString[0], dateString[1] - 1, dateString[2]);

          this.bindChart();

        });
      }
      else {
        this.bindChart();
      }
    });
    this.blockChartRebind = false;
    this.Shared.offerPageReloadStatus.subscribe(res => {
      if (res && this.blockChartRebind) {
        this.bindChart();
      }
      this.blockChartRebind = true;
    });
  }

  get Add_loiStartDate() { return this.EditPhaseForm.get('Add_loiStartDate'); }
  get Add_loiEndDate() { return this.EditPhaseForm.get('Add_loiEndDate'); }
  get Add_psaStartDate() { return this.EditPhaseForm.get('Add_psaStartDate'); }
  get Add_psaEndDate() { return this.EditPhaseForm.get('Add_psaEndDate'); }
  get Add_ddStartDate() { return this.EditPhaseForm.get('Add_ddStartDate'); }
  get Add_ddEndDate() { return this.EditPhaseForm.get('Add_ddEndDate'); }
  get Add_hcStartDate() { return this.EditPhaseForm.get('Add_hcStartDate'); }
  get Add_hcEndDate() { return this.EditPhaseForm.get('Add_hcEndDate'); }
  get Phase_IsLOICompleted() { return this.EditPhaseForm.get('Phase_IsLOICompleted'); }
  get LOIPhase_Completed() { return this.EditPhaseForm.get('LOIPhase_Completed'); }
  get Phase_IsPSACompleted() { return this.EditPhaseForm.get('Phase_IsPSACompleted'); }
  get PSAPhase_Completed() { return this.EditPhaseForm.get('PSAPhase_Completed'); }
  get Phase_IsDDCompleted() { return this.EditPhaseForm.get('Phase_IsDDCompleted'); }
  get DDPhase_Completed() { return this.EditPhaseForm.get('DDPhase_Completed'); }
  get Phase_IsHCCompleted() { return this.EditPhaseForm.get('Phase_IsHCCompleted'); }
  get HCPhase_Completed() { return this.EditPhaseForm.get('HCPhase_Completed'); }

  exchangeOffer = false;
  tradeStart: number;
  offerType = "Trade";
  plotBand = [];
  setPlotBands() {
    if (this.exchangeOffer) {
      this.plotBand = [{
        color: '#ffffff',
        from: this.startDate,
        to: this.startDate,
        label: {
          text: '<b>Deal Start</b><br>' + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.startDate))),
          align: 'left',
          x: 10,
          y: 20,
          useHTML: true,
          style: {
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'none',
            width: 'auto'
          }
        }
      }, {
        color: '#c0211f',
        from: this.currentDate,
        to: this.currentDate,
        label: {
          text: '<b>Today</b><br><span>' + (this.Validation.IsinValid(this.currentDate) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.currentDate)))) + '</span>',
          align: this.setCurrentDatePosition(this.tradeStart, this.endDate, this.currentDate) ? 'right' : 'left',
          x: this.setCurrentDatePosition(this.tradeStart, this.endDate, this.currentDate) ? -10 : 10,
          y: 150,
          useHTML: true,
          style: {
            fontSize: '12px', 
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'none',
            width: 'auto'
          }
        }
      },
      {
        color: '#bd2765',
        from: this.date_45,
        to: this.date_45,
        label: {
          text: '<b>Identification Period</b><br>' + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.date_45))),
          align: 'left',
          x: 10,
          y: this.chartDataReesponse.find(o => o.OfferStatus == 467) != null ? 70 : 80,
          useHTML: true,
          style: {
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'none',
            width: 'auto'
          }
        }
      },
      {
        color: '#ffffff',
        from: this.endDate,
        to: this.endDate,
        label: {
          text: '<div style="text-align: right;"><b>Deal End</b></div>' + (this.Validation.IsinValid(this.endDate) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.endDate)))),
          align: 'right',
          x: -10,
          y: 20,
          useHTML: true,
          style: {
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'none',
            width: 'auto'
          }
        }
      }]
    }
    else {
      this.plotBand = [{
        color: '#ffffff',
        from: this.startDate,
        to: this.startDate,
        label: {
          text: '<b>Deal Start</b><br>' + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.startDate))),
          align: 'left',
          x: 10,
          y: 20,
          useHTML: true,
          style: {
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'none',
            width: 'auto'
          }
        }
      }, {
        color: '#c0211f',
        from: this.currentDate,
        to: this.currentDate,
        label: {
          text: '<b>Today</b><br><span>' + (this.Validation.IsinValid(this.currentDate) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.currentDate)))) + '</span>',
          align: this.setCurrentDatePosition(this.tradeStart, this.endDate, this.currentDate) ? 'right' : 'left',
          x: this.setCurrentDatePosition(this.tradeStart, this.endDate, this.currentDate) ? -10 : 10,
          y: 150,
          useHTML: true,
          style: {
            fontSize: '12px',
            
            
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'none',
            width: 'auto'
          }
        }
      },
      {
        color: '#ffffff',
        from: this.endDate,
        to: this.endDate,
        label: {
          text: '<div style="text-align: right;"><b>Deal End</b></div>' + (this.Validation.IsinValid(this.endDate) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.endDate)))),
          align: 'right',
          x: -10,
          y: 20,
          useHTML: true,
          style: {
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'none',
            width: 'auto'
          }
        }
      }]
    }
  }
  bindChart() {

    this.currentDate = this.Validation.getCurrentDate();
    this.chartDataReesponse = [];
    this.chartData = [];
    this.offerService.GetOfferProgressBriefChartData(this.offerGuid).subscribe(res => {
      this.chartDataReesponse = res;
      let count = 1;
      let id = [];

      let dataUsedCount = this.chartDataReesponse.length;
      let highdate = 0;
      this.endDate = 0;
      this.PhaseInputModel.LOIStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300)?.StartDate));
      this.PhaseInputModel.LOIEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300)?.EndDate));
      this.PhaseInputModel.PSAStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301)?.StartDate));
      this.PhaseInputModel.PSAEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301)?.EndDate));
      this.PhaseInputModel.DDStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302)?.StartDate));
      this.PhaseInputModel.DDEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302)?.EndDate));
      this.PhaseInputModel.HCStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303)?.StartDate));
      this.PhaseInputModel.HCEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303)?.EndDate));

      //if (this.chartDataReesponse.find(i => i.Id == 2300).CompletedDate != null) {
      //  this.PhaseInputModel.LOICompletedDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).CompletedDate));
      //}
      //else {
      //  this.PhaseInputModel.LOICompletedDate = null;
      //}
      //this.PhaseInputModel.IsLOICompleted = this.chartDataReesponse.find(i => i.Id == 2300).IsCompleted;

      //if (this.chartDataReesponse.find(i => i.Id == 2301).CompletedDate != null) {
      //  this.PhaseInputModel.PSACompletedDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).CompletedDate));
      //}
      //else {
      //  this.PhaseInputModel.PSACompletedDate = null;
      //}

      //this.PhaseInputModel.IsPSACompleted = this.chartDataReesponse.find(i => i.Id == 2301).IsCompleted;

      //if (this.chartDataReesponse.find(i => i.Id == 2302).CompletedDate != null) {
      //  this.PhaseInputModel.DDCompletedDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).CompletedDate));
      //}
      //else {
      //  this.PhaseInputModel.DDCompletedDate = null;
      //}

      //this.PhaseInputModel.IsDDCompleted = this.chartDataReesponse.find(i => i.Id == 2302).IsCompleted;

      //if (this.chartDataReesponse.find(i => i.Id == 2303).CompletedDate != null) {
      //  this.PhaseInputModel.HCCompletedDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).CompletedDate));
      //}
      //else {
      //  this.PhaseInputModel.HCCompletedDate = null;
      //}
      //this.PhaseInputModel.IsHCCompleted = this.chartDataReesponse.find(i => i.Id == 2303).IsCompleted;

      if (this.EditPhaseForm == null) {
        this.EditPhaseForm = new FormGroup({
          'Add_loiStartDate': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.LOIStartDate), [
            DateValidator
          ]),
          'Add_loiEndDate': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.LOIEndDate), [
            DateValidator
          ]),
          'Add_psaStartDate': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.PSAStartDate), [
            DateValidator
          ]),
          'Add_psaEndDate': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.PSAEndDate), [
            DateValidator
          ]),
          'Add_ddStartDate': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.DDStartDate), [
            DateValidator
          ]),
          'Add_ddEndDate': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.DDEndDate), [
            DateValidator
          ]),
          'Add_hcStartDate': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.HCStartDate), [
            DateValidator
          ]),
          'Add_hcEndDate': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.HCEndDate), [
            DateValidator
          ]),
          //'LOIPhase_Completed': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.LOICompletedDate), [
          //  DateValidator
          //]),
          //'Phase_IsLOICompleted': new FormControl(this.PhaseInputModel.IsLOICompleted),
          //'PSAPhase_Completed': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.PSACompletedDate), [
          //  DateValidator
          //]),
          //'Phase_IsPSACompleted': new FormControl(this.PhaseInputModel.IsPSACompleted),
          //'DDPhase_Completed': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.DDCompletedDate), [
          //  DateValidator
          //]),
          //'Phase_IsDDCompleted': new FormControl(this.PhaseInputModel.IsDDCompleted),
          //'HCPhase_Completed': new FormControl(this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.HCCompletedDate), [
          //  DateValidator
          //]),
          //'Phase_IsHCCompleted': new FormControl(this.PhaseInputModel.IsHCCompleted),
        })
      }

      this.chartDataReesponse.forEach(item => {
        const IdIndex = id.indexOf(item.Id);

        if (IdIndex < 0) {
          id.push(item.Id);

          highdate = this.Validation.convertDateToUTCStamp(item.EndDate);

          let lowDate = 0;
          lowDate = this.Validation.convertDateToUTCStamp(item.StartDate);

          let HoverText = "Start Date: " + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(item.StartDate))) +
            " End Date: " + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(item.EndDate)));

          if (count == 1) {
            this.startDate = lowDate;
            if ((this.Validation.IsinValid(this.tradeStart) || this.tradeStart === 0) || !this.exchangeOffer) {
              this.tradeStart = this.startDate;
            }

            this.date_45 = this.tradeStart + (24 * 3600 * 1000 * 45);
            if (item.OfferStatus != 467) {
              const uptotoday = {
                name: "SUB",
                color: "#81a4bf",
                pointWidth: 10,
                showInLegend: false,
                data: [{
                  x: 0,
                  low: this.startDate < this.tradeStart ? this.startDate : this.tradeStart,
                  high: this.currentDate,
                  hoverText: "In progress",
                }],
              };
              this.chartData.push(uptotoday);
            }
          }

          const singleData = {
            name: this.Validation.getTaskPhaseName(item.Id, item.Name),
            color: this.getChartColor(item.Id, item.OfferStatus),
            //color: this.Validation.colorPicker(lowDate, highdate, this.currentDate, item.StatusId),
            pointWidth: 25,
            data: [{
              x: 0.5,
              low: lowDate,
              high: highdate,
              hoverText: HoverText,
            }],
          };
          this.chartData.push(singleData);
        }
        if (this.endDate < highdate) {
          this.endDate = highdate;
        }

        if (count == this.chartDataReesponse.length && item.OfferStatus != 467) {
          //this.endDate = highdate;
          const coming = {
            name: "SUB",
            color: "#e6e6e6",
            pointWidth: 10,
            showInLegend: false,
            data: [{
              x: 0,
              low: this.currentDate,
              high: this.endDate,
              hoverText: "Upcoming",
            }],
          };
          this.chartData.push(coming);
        }
        count++;
      });
      if (this.chartData.length > 0) {
        this.setPlotBands();
      }
      Highcharts.chart('divchart', {
        chart: {
          type: 'columnrange',
          inverted: true
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: [''],
          type: 'datetime',
          visible: false
        },
        yAxis: {
          title: {
            text: ''
          },
          type: 'datetime',
          min: this.startDate < this.tradeStart ? this.startDate : this.tradeStart,
          max: this.endDate,
          dateTimeLabelFormats: {
            day: '%e %b %y',
            month: "%b-%y"
          },
          labels: {
            format: '{value:%m-%e-%Y}',
            enabled: false // to hide y axis 
          },
          plotBands: this.plotBand,
          tickPositions: [this.startDate, this.exchangeOffer ? this.date_45 : this.startDate, this.currentDate, this.endDate]
          //this.date_45,
        },
        legend: {
          enabled: false
        },
        //bar: {
        //    groupPadding: 0,
        //    pointPadding: 0,
        //},
        plotOptions: {
          columnrange: {
            grouping: false,
            //borderRadius: 5,
          },
          series: {
            stacking: 'normal',
            events: {
              legendItemClick: function () {
                return false;
              }
            },
            dataLabels: {
              enabled: true,
              align: 'center',
              color: '#000000',
              x: -10,
              formatter: function () {
                if (this.series.name != "SUB") {
                  return '<b>' + this.series.name.split('-')[0] + '</b>';
                }
                else {
                  return '';
                }
              }
            },
          },
        },
        series: this.chartData,
        exporting: {
          enabled: false
        }, credits: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            let index = this.series.data.indexOf(this.point);
            if (this.series.name != "SUB") {
              let name = [] = this.series.name.split('-');
              console.log(this.series.data[index]);
              return '<b>' + name[name.length - 1] + '</b> <br>' + this.series.data[index]["hoverText"]//.hoverText
            }
            else {
              return '<b>' + this.series.data[index]["hoverText"] + '</b>'
              return false;
            }
          }
        }
      });

      //this.chart = chart;

      this.Loader.display(false)
    });
  }

  getChartColor(phaseid, offerStatus) {
    if (offerStatus == 467 || offerStatus == 466) {
      return ' #59595B ';
    }
    const colors = [' #A7A8A9 ', ' #003A5D ', ' #02C29F ', ' #FFC32B ', ' #FF4438 ']
    switch (phaseid) {
      case 2300: {
        return colors[0];
      }
      case 2301: {
        return colors[1];
      }
      case 2302: {
        return colors[2];
      }
      case 2303: {
        return colors[3];
      }
      case 2304: {
        return colors[4];
      }
      case 350: {
        return "#5bc7af";
      }
      default: {
        return "#5bc7af";
      }
    }
  }

  setCurrentDatePosition(startDate: number, endDate: number, currentDate: number) {
    if ((endDate - currentDate) <= 172800000) {
      return true;
    }
    return false;
  }

  AllowLOIEdit = true;
  AllowPSAEdit = true;
  AllowDDEdit = true;
  AllowHCEdit = true;
  AllowEdit = true;

  UpdatePhaseDate(editAll: boolean = false, type: number) {
    this.isEditPhaseFormSubmitted = true;
    /*  let type = this.phaseNumber;*/

    if (!this.EditPhaseForm.invalid) {
      this.PhaseInput.OfferGuid = this.offerGuid;
      this.PhaseInput.IsEditAllDates = editAll;
      this.PhaseInput.loggedinuserid = this.user.Id;
      this.isEditPhaseFormSubmitted = true;

      switch (type) {
        case 1: {
          this.PhaseInput.StartDate = this.Validation.utcify(this.PhaseInputModel.LOIStartDate);
          this.PhaseInput.EndDate = this.Validation.utcify(this.PhaseInputModel.LOIEndDate);
          this.PhaseInput.AssociatedStatusId = 2300;
          //this.PhaseInput.CompletedDate = this.Validation.utcify(this.PhaseInputModel.LOICompletedDate);
          //this.PhaseInput.IsPhaseCompleted = this.PhaseInputModel.IsLOICompleted;

          break;
        }
        case 2: {
          this.PhaseInput.StartDate = this.Validation.utcify(this.PhaseInputModel.PSAStartDate);
          this.PhaseInput.EndDate = this.Validation.utcify(this.PhaseInputModel.PSAEndDate);
          this.PhaseInput.AssociatedStatusId = 2301;
          //this.PhaseInput.CompletedDate = this.Validation.utcify(this.PhaseInputModel.PSACompletedDate);
          //this.PhaseInput.IsPhaseCompleted = this.PhaseInputModel.IsPSACompleted;

          break;
        }
        case 3: {
          this.PhaseInput.StartDate = this.Validation.utcify(this.PhaseInputModel.DDStartDate);
          this.PhaseInput.EndDate = this.Validation.utcify(this.PhaseInputModel.DDEndDate);
          this.PhaseInput.AssociatedStatusId = 2302;
          //this.PhaseInput.CompletedDate = this.Validation.utcify(this.PhaseInputModel.DDCompletedDate);
          //this.PhaseInput.IsPhaseCompleted = this.PhaseInputModel.IsDDCompleted;

          break;
        }
        case 4: {
          this.PhaseInput.StartDate = this.Validation.utcify(this.PhaseInputModel.HCStartDate);
          this.PhaseInput.EndDate = this.Validation.utcify(this.PhaseInputModel.HCEndDate);
          this.PhaseInput.AssociatedStatusId = 2303;
          //this.PhaseInput.CompletedDate = this.Validation.utcify(this.PhaseInputModel.HCCompletedDate);
          //this.PhaseInput.IsPhaseCompleted = this.PhaseInputModel.IsHCCompleted;

          break;
        }
      }

      this.Loader.display(true);
      this.offerService.UpdateTaskPhaseDetails(this.PhaseInput).subscribe(res => {
        if (res) {
          this.Shared.reloadOfferDetail(true);
          this.modalRef.hide();
          this.modalRefPhaseDateConfirmation.hide();
          this._toastService.addToast({ title: 'Success', msg: 'Phase updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: "Failed to update phase", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
        this.Loader.display(false);
      });
    }
  }

  openModal(template: TemplateRef<any>, classes) {
    this.isEditPhaseFormSubmitted = false;
    this.AllowLOIEdit = true;
    this.AllowPSAEdit = true;
    this.AllowDDEdit = true;
    this.AllowHCEdit = true;
    this.isLOIPhaseCompletedDateInvalid = false;
    this.isPSAPhaseCompletedDateInvalid = false;
    this.isDDPhaseCompletedDateInvalid = false;
    this.isHCPhaseCompletedDateInvalid = false;
    this.modifiedPSADate = null;
    this.modifiedDDDate = null;
    this.modifiedHCDate = null;
    this.EditPhaseForm.reset();

    this.PhaseInputModel.LOIStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).StartDate));
    this.PhaseInputModel.LOIEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).EndDate));

    this.PhaseInputModel.PSAStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).StartDate));
    this.PhaseInputModel.PSAEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).EndDate));

    this.PhaseInputModel.DDStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).StartDate));
    this.PhaseInputModel.DDEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).EndDate));

    this.PhaseInputModel.HCStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).StartDate));
    this.PhaseInputModel.HCEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).EndDate));
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  openSaveModal(template: TemplateRef<any>, classes, phaseNumber: number, editAll: boolean) {
    this.isEditPhaseFormSubmitted = true;
    this.isLOIPhaseCompletedDateInvalid = false;
    this.isPSAPhaseCompletedDateInvalid = false;
    this.isDDPhaseCompletedDateInvalid = false;
    this.isHCPhaseCompletedDateInvalid = false;

    switch (phaseNumber) {
      case 1: {

        if (this.PhaseInputModel.LOIStartDate > this.PhaseInputModel.LOIEndDate) {
          this._toastService.addToast({ title: 'Error Occurred', msg: "LOI Start date should not be greater than LOI End date", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (!this.Validation.IsDate(this.PhaseInputModel.LOIStartDate)) {
          return;
        }

        if (!this.Validation.IsDate(this.PhaseInputModel.LOIEndDate)) {
          return;
        }

        //if (this.PhaseInputModel.IsLOICompleted && !this.Validation.IsDate(this.PhaseInputModel.LOICompletedDate)) {
        //  this.isLOIPhaseCompletedDateInvalid = true;
        //  return;
        //}
        //else {
        //  this.isLOIPhaseCompletedDateInvalid = false;
        //}

        break;
      }
      case 2: {

        if (this.PhaseInputModel.PSAStartDate > this.PhaseInputModel.PSAEndDate) {
          this._toastService.addToast({ title: 'Error Occurred', msg: "PSA Start date should not be greater than PSA End date", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (!this.Validation.IsDate(this.PhaseInputModel.PSAStartDate)) {
          return;
        }

        if (!this.Validation.IsDate(this.PhaseInputModel.PSAEndDate)) {
          return;
        }

        //if (this.PhaseInputModel.IsPSACompleted && !this.Validation.IsDate(this.PhaseInputModel.PSACompletedDate)) {
        //  this.isPSAPhaseCompletedDateInvalid = true;
        //  return;
        //}
        //else {
        //  this.isPSAPhaseCompletedDateInvalid = false;
        //}

        break;
      }
      case 3: {
        if (this.PhaseInputModel.DDStartDate > this.PhaseInputModel.DDEndDate) {
          this._toastService.addToast({ title: 'Error Occurred', msg: "DD Start date should not be greater than DD End date", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (!this.Validation.IsDate(this.PhaseInputModel.DDStartDate)) {
          return;
        }

        if (!this.Validation.IsDate(this.PhaseInputModel.DDEndDate)) {
          return;
        }

        //if (this.PhaseInputModel.IsDDCompleted && !this.Validation.IsDate(this.PhaseInputModel.DDCompletedDate)) {
        //  this.isDDPhaseCompletedDateInvalid = true;
        //  return;
        //}
        //else {
        //  this.isDDPhaseCompletedDateInvalid = false;
        //}

        break;
      }
      case 4: {
        if (this.PhaseInputModel.HCStartDate > this.PhaseInputModel.HCEndDate) {
          this._toastService.addToast({ title: 'Error Occurred', msg: "HC Start date should not be greater than HC End date", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (!this.Validation.IsDate(this.PhaseInputModel.HCStartDate)) {
          return;
        }

        if (!this.Validation.IsDate(this.PhaseInputModel.HCEndDate)) {
          return;
        }

        //if (this.PhaseInputModel.IsHCCompleted && !this.Validation.IsDate(this.PhaseInputModel.HCCompletedDate)) {
        //  this.isHCPhaseCompletedDateInvalid = true;
        //  return;
        //}
        //else {
        //  this.isHCPhaseCompletedDateInvalid = false;
        //}

        break;
      }
    }

    //this.modalRefPhaseDateConfirmation = this.modalService.show(template, { class: classes });
    //this.phaseNumber = phaseNumber;
    this.UpdatePhaseDate(editAll, phaseNumber);
  }

  onEditPhaseCancel() {
    this.isEditPhaseFormSubmitted = false;
    this.modifiedPSADate = null;
    this.modifiedDDDate = null;
    this.modifiedHCDate = null;

    this.PhaseInputModel.LOIStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).StartDate));
    this.PhaseInputModel.LOIEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).EndDate));

    this.PhaseInputModel.PSAStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).StartDate));
    this.PhaseInputModel.PSAEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).EndDate));

    this.PhaseInputModel.DDStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).StartDate));
    this.PhaseInputModel.DDEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).EndDate));

    this.PhaseInputModel.HCStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).StartDate));
    this.PhaseInputModel.HCEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).EndDate));

    this.modalRef.hide();
  }

  EditPhaseDate(phaseNumber: number) {
    this.isEditPhaseFormSubmitted = false;
    this.modifiedPSADate = null;
    this.modifiedDDDate = null;
    this.modifiedHCDate = null;

    switch (phaseNumber) {
      case 1: {
        this.AllowLOIEdit = false;
        this.AllowPSAEdit = true;
        this.AllowDDEdit = true;
        this.AllowHCEdit = true;
        break;
      }
      case 2: {
        this.AllowLOIEdit = true;
        this.AllowPSAEdit = false;
        this.AllowDDEdit = true;
        this.AllowHCEdit = true;
        break;
      }
      case 3: {
        this.AllowLOIEdit = true;
        this.AllowPSAEdit = true;
        this.AllowDDEdit = false;
        this.AllowHCEdit = true;
        break;
      }
      case 4: {
        this.AllowLOIEdit = true;
        this.AllowPSAEdit = true;
        this.AllowDDEdit = true;
        this.AllowHCEdit = false;
        break;
      }
    }

  }

  CancelPhaseDate(phaseNumber: number) {
    this.isEditPhaseFormSubmitted = false;
    this.modifiedPSADate = null;
    this.modifiedDDDate = null;
    this.modifiedHCDate = null;

    switch (phaseNumber) {
      case 1: {
        this.PhaseInputModel.LOIStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).StartDate));
        this.PhaseInputModel.LOIEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).EndDate));

        //if (this.chartDataReesponse.find(i => i.Id == 2300).CompletedDate != null) {
        //  this.PhaseInputModel.LOICompletedDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).CompletedDate));
        //}
        //else {
        //  this.PhaseInputModel.LOICompletedDate = null;
        //}
        //this.PhaseInputModel.IsLOICompleted = this.chartDataReesponse.find(i => i.Id == 2300).IsCompleted;
        break;
      }
      case 2: {
        this.PhaseInputModel.PSAStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).StartDate));
        this.PhaseInputModel.PSAEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).EndDate));

        //if (this.chartDataReesponse.find(i => i.Id == 2301).CompletedDate != null) {
        //  this.PhaseInputModel.PSACompletedDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).CompletedDate));
        //}
        //else {
        //  this.PhaseInputModel.PSACompletedDate = null;
        //}
        //this.PhaseInputModel.IsPSACompleted = this.chartDataReesponse.find(i => i.Id == 2301).IsCompleted;
        break;
      }
      case 3: {
        this.PhaseInputModel.DDStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).StartDate));
        this.PhaseInputModel.DDEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).EndDate));

        //if (this.chartDataReesponse.find(i => i.Id == 2302).CompletedDate != null) {
        //  this.PhaseInputModel.DDCompletedDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).CompletedDate));
        //}
        //else {
        //  this.PhaseInputModel.DDCompletedDate = null;
        //}
        //this.PhaseInputModel.IsDDCompleted = this.chartDataReesponse.find(i => i.Id == 2302).IsCompleted;

        break;
      }
      case 4: {
        this.PhaseInputModel.HCStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).StartDate));
        this.PhaseInputModel.HCEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).EndDate));

        //if (this.chartDataReesponse.find(i => i.Id == 2303).CompletedDate != null) {
        //  this.PhaseInputModel.HCCompletedDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).CompletedDate));
        //}
        //else {
        //  this.PhaseInputModel.HCCompletedDate = null;
        //}
        //this.PhaseInputModel.IsHCCompleted = this.chartDataReesponse.find(i => i.Id == 2303).IsCompleted;
        break;
      }
    }

    this.AllowLOIEdit = true;
    this.AllowPSAEdit = true;
    this.AllowDDEdit = true;
    this.AllowHCEdit = true;
  }

  modifiedPSADate: string = null;
  modifiedDDDate: string = null;
  modifiedHCDate: string = null;
  onChange(phaseNumber) {
    switch (phaseNumber) {
      case 1: {
        var loiStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).StartDate));
        var loiEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2300).EndDate));

        if (this.Validation.formatDatetoMMDDYYYY(loiStartDate) == this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.LOIStartDate) && this.Validation.formatDatetoMMDDYYYY(loiEndDate) == this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.LOIEndDate)) {
          return;
        }

        var psaStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).StartDate));
        var psaEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).EndDate));
        var ddStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).StartDate));
        var ddEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).EndDate));
        var hcStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).StartDate));
        var hcEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).EndDate));

        var actualEndDate;

        var onlyStartDateUpdated = (this.Validation.formatDatetoMMDDYYYY(loiStartDate) != this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.LOIStartDate)) && (this.Validation.formatDatetoMMDDYYYY(loiEndDate) == this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.LOIEndDate));

        if (onlyStartDateUpdated) {
          var dayDiff = this.Validation.DateDiff(loiStartDate, loiEndDate);
          if (this.PhaseInputModel.LOIStartDate < loiStartDate) {
            dayDiff = -1 * dayDiff;
          }

          actualEndDate = this.Validation.addDays(loiEndDate, dayDiff);
        }
        else {
          actualEndDate = this.PhaseInputModel.LOIEndDate;
        }

        var modifiedPSAStartDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(loiEndDate, psaStartDate));
        var modifiedPSAEndDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(loiEndDate, psaEndDate));

        this.modifiedPSADate = this.Validation.formatDatetoMMDDYYYY(modifiedPSAStartDate).toString() + ' - ' + this.Validation.formatDatetoMMDDYYYY(modifiedPSAEndDate).toString();

        var modifiedDDStartDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(loiEndDate, ddStartDate));
        var modifiedDDEndDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(loiEndDate, ddEndDate));

        this.modifiedDDDate = this.Validation.formatDatetoMMDDYYYY(modifiedDDStartDate).toString() + ' - ' + this.Validation.formatDatetoMMDDYYYY(modifiedDDEndDate).toString();

        var modifiedHCStartDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(loiEndDate, hcStartDate));
        var modifiedHCEndDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(loiEndDate, hcEndDate));

        this.modifiedHCDate = this.Validation.formatDatetoMMDDYYYY(modifiedHCStartDate).toString() + ' - ' + this.Validation.formatDatetoMMDDYYYY(modifiedHCEndDate).toString();

        break;
      }
      case 2: {
        var psaStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).StartDate));
        var psaEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2301).EndDate));

        if (this.Validation.formatDatetoMMDDYYYY(psaStartDate) == this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.PSAStartDate) && this.Validation.formatDatetoMMDDYYYY(psaEndDate) == this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.PSAEndDate)) {
          return;
        }

        var ddStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).StartDate));
        var ddEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).EndDate));
        var hcStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).StartDate));
        var hcEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).EndDate));

        var actualEndDate;

        var onlyStartDateUpdated = (this.Validation.formatDatetoMMDDYYYY(psaStartDate) != this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.PSAStartDate)) && (this.Validation.formatDatetoMMDDYYYY(psaEndDate) == this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.PSAEndDate));

        if (onlyStartDateUpdated) {
          var dayDiff = this.Validation.DateDiff(psaStartDate, psaEndDate);
          if (this.PhaseInputModel.PSAStartDate < psaStartDate) {
            dayDiff = -1 * dayDiff;
          }

          actualEndDate = this.Validation.addDays(psaEndDate, dayDiff);
        }
        else {
          actualEndDate = this.PhaseInputModel.PSAEndDate;
        }

        var modifiedDDStartDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(psaEndDate, ddStartDate));
        var modifiedDDEndDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(psaEndDate, ddEndDate));

        this.modifiedDDDate = this.Validation.formatDatetoMMDDYYYY(modifiedDDStartDate).toString() + ' - ' + this.Validation.formatDatetoMMDDYYYY(modifiedDDEndDate).toString();

        var modifiedHCStartDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(psaEndDate, hcStartDate));
        var modifiedHCEndDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(psaEndDate, hcEndDate));

        this.modifiedHCDate = this.Validation.formatDatetoMMDDYYYY(modifiedHCStartDate).toString() + ' - ' + this.Validation.formatDatetoMMDDYYYY(modifiedHCEndDate).toString();

        break;
      }
      case 3: {
        var ddStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).StartDate));
        var ddEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2302).EndDate));

        if (this.Validation.formatDatetoMMDDYYYY(ddStartDate) == this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.DDStartDate) && this.Validation.formatDatetoMMDDYYYY(ddEndDate) == this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.DDEndDate)) {
          return;
        }

        var hcStartDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).StartDate));
        var hcEndDate = this.Validation.convertUTCDateToLocalDate(new Date(this.chartDataReesponse.find(i => i.Id == 2303).EndDate));

        var actualEndDate;

        var onlyStartDateUpdated = (this.Validation.formatDatetoMMDDYYYY(ddStartDate) != this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.DDStartDate)) && (this.Validation.formatDatetoMMDDYYYY(ddEndDate) == this.Validation.formatDatetoMMDDYYYY(this.PhaseInputModel.DDEndDate));

        if (onlyStartDateUpdated) {
          var dayDiff = this.Validation.DateDiff(ddStartDate, ddEndDate);
          if (this.PhaseInputModel.DDStartDate < ddStartDate) {
            dayDiff = -1 * dayDiff;
          }

          actualEndDate = this.Validation.addDays(ddEndDate, dayDiff);
        }
        else {
          actualEndDate = this.PhaseInputModel.DDEndDate;
        }

        var modifiedHCStartDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(ddEndDate, hcStartDate));
        var modifiedHCEndDate = this.Validation.addDays(actualEndDate, this.Validation.DateDiff(ddEndDate, hcEndDate));

        this.modifiedHCDate = this.Validation.formatDatetoMMDDYYYY(modifiedHCStartDate).toString() + ' - ' + this.Validation.formatDatetoMMDDYYYY(modifiedHCEndDate).toString();

        break;
      }
      case 4: {

        break;
      }
    }
  }

}
